import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

import dataVisGif from '../assets/projects/healthcare/DataVisualisation.gif';
import petriGif from '../assets/projects/healthcare/Petri.gif';
import keyboardGif from '../assets/projects/healthcare/Keyboard.gif';
import microscopeGif from '../assets/projects/healthcare/Microscope.gif';

const Pharmaceutical = () => {
  return (
    <ProjectLayout
      title="Healthcare"
      description={[
        'This work includes 3D medical animations and scientific visualisation, intended for internal use and specialist presentations within global pharmaceutical organisations.',
      ]}
      credits={['3D Medical Animation', 'Scientific Visualisation', 'Virtual Production']}
    >
      {/* Style frames — text above visuals */}
      <div className="pm-section">
        <h2 className="pm-section__title">3D Visualizations for Social Media</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Created a 3D laboratory environment to render style frames for a medical client&apos;s
          social channels. These detailed visualizations showcased scientific equipment and
          processes with photo-realistic quality, supporting engaging visual content for their
          digital presence.
        </p>
      </div>
      <div className="pm-row">
        <img src={petriGif} alt="Petri Dish Animation" />
        <img src={keyboardGif} alt="Laboratory Keyboard" />
      </div>
      <img className="pm-full" src={microscopeGif} alt="Microscope Animation" />

      {/* Infographics — text above visuals */}
      <div className="pm-section">
        <h2 className="pm-section__title">Infographics</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Created 3D medical animations and scientific visualizations for presentations at
          cardiology congresses and healthcare conferences. Developed assets for video, virtual
          reality (VR) and augmented reality (AR) applications, helping medical clients
          communicate complex data to professionals in an engaging, accessible way.
        </p>
      </div>
      <img className="pm-full" src={dataVisGif} alt="Data Visualisation" />
    </ProjectLayout>
  );
};

export default Pharmaceutical;
